import wx from "weixin-js-sdk";
import request from "@/utils/Request";
import {Message} from 'element-ui';

const wxUtil = {
  initFlag: false,
  configure: {
    debug: false,
    appId: '',
    timestamp: 0,
    signature: '',
    nonceStr: '',
    jsApiList: ['checkJsApi', 'openLocation', 'getLocation'],
    latitude: '',
    longitude: '',
    address: '',
    name: '',
    scale: '15',
    infoUrl: '',
    getUrl: function (){
      let split = window.location.href.split('#');
      let url = split[0];
      return encodeURIComponent(url);
    }
  },

  init: function () {
    if(!wxUtil.initFlag){
      wxUtil.getSignature().then(res => {
        if (!res.success) {
          return false;
        }
        wxUtil.configure.appId = res.data.appId;
        wxUtil.configure.timestamp = parseInt(res.data.timestamp);
        wxUtil.configure.signature = res.data.signature;
        wxUtil.configure.nonceStr = res.data.nonceStr;
        wxUtil.config();
      })
    }
  },

  /**
   * 获取微信签名
   */
  getSignature: function () {
    return request({
      url: '/appointment-web/facilityController/docAccessToken',
      method: 'POST',
      params: {
        url: wxUtil.configure.getUrl(),
      }
    });
  },
  config: function () {
    wx.config({
      debug: wxUtil.configure.debug,
      appId: wxUtil.configure.appId,
      timestamp: wxUtil.configure.timestamp,
      nonceStr: wxUtil.configure.nonceStr,
      signature: wxUtil.configure.signature,
      jsApiList: wxUtil.configure.jsApiList
    });

    wxUtil.ready();
    wxUtil.error();
  },
  openLocation: function (latitude, longitude, name, address, scale, infoUrl) {
    wx.openLocation({
      latitude: Number(latitude), // 纬度，浮点数，范围为90 ~ -90
      longitude: Number(longitude), // 经度，浮点数，范围为180 ~ -180。
      name: name ?? '', // 位置名
      address: address ?? '', // 地址详情说明
      scale: scale || 15, // 地图缩放级别,整型值,范围从1~28。默认为最大
      infoUrl: infoUrl ?? '' // 在查看位置界面底部显示的超链接,可点击跳转
    });
  },

  getLocation: function () {
    wx.getLocation({
      type: 'wgs84',
      success: function (res) {
        wxUtil.configure.latitude = res.latitude;
        wxUtil.configure.longitude = res.longitude;
      }
    });
  },
  ready: function () {
    /**
     * config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，
     * config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，
     * 则须把相关接口放在ready函数中调用来确保正确执行。
     * 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
     */
    wx.ready(function () {
      wxUtil.initFlag = true;
      wx.checkJsApi({
        jsApiList: wxUtil.configure.jsApiList, // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
        success: function (res) {
        }
      });

      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          window.miniprogram = false;
        } else {
          window.miniprogram = false;
        }
      })

      // wx.getLocation({
      //   type: 'wgs84',
      //   success: function (res) {
      //     console.log('getLocation', JSON.stringify(res));
      //     wxUtil.configure.latitude = res.latitude;
      //     wxUtil.configure.longitude = res.longitude;
      //   }
      // });
    });
/*    wx.openLocation({
      latitude: wxUtil.configure.latitude, // 纬度，浮点数，范围为90 ~ -90
      longitude: wxUtil.configure.longitude, // 经度，浮点数，范围为180 ~ -180。
      name: wxUtil.configure.name ?? '', // 位置名
      address: wxUtil.configure.address ?? '', // 地址详情说明
      scale:  wxUtil.configure.scale || 15, // 地图缩放级别,整型值,范围从1~28。默认为最大
      infoUrl: wxUtil.configure.infoUrl ?? '' // 在查看位置界面底部显示的超链接,可点击跳转
    });*/
  },
  error: function () {
    /**
     * config信息验证失败会执行error函数，如签名过期导致验证失败，
     * 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
     */
    wx.error(function (res) {
      console.error('wx.error', JSON.stringify(res));
      Message.error('微信配置失败' + JSON.stringify(res));
    });
  }
};


export default wxUtil;
